import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import classnames from 'classnames';
import queryString from 'query-string';
import {
  Tabs, Toast, Modal, ActivityIndicator,
} from 'antd-mobile';
import TIM from 'tim-js-sdk';
import PropTypes from 'prop-types';
import LiveComponent from '../../components/live/live';
import SuspendButton from '../../components/suspendButton/suspendButton';
import TencentVideoPLay from './tencentVideoPLay';
import LiveLogin from './liveLogin/liveLogin';
import WXShare from '../../components/WxShare';

import styles from './styles.module.less';

import tim from '../../public/js/tim';
import config from '../../config/app-config';

import {
  getImUserSig,
  getImOpenId,
  getImAppId,
  verifyGetLive,
  getOpenType,
  checkCode,
  verifyVodLive,
  getLiveProduct,
} from '../../service/chat-service';
import tools from '../../utils/tools';

import moren from '../../public/images/moren.png';
import pngInput from '../../public/images/input.png';
import linkProduct from '../../public/images/link_product.png';
import noLive from '../../public/images/nolive.png';
import pngTuiguang from '../../public/images/tuiguang.png';
import pngShangpin from '../../public/images/shangpin.png';
import pngOnline from '../../public/images/onlinePer.png';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  setConversationID: PropTypes.func,
  setEndLive: PropTypes.func,
  pushCurrentMessageList: PropTypes.func,
  setLivePerson: PropTypes.func,
  endLive: PropTypes.bool,
  livePerson: PropTypes.number,
  currentMessageList: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })),
};
const defaultProps = {
  setConversationID: () => {},
  setEndLive: () => {},
  pushCurrentMessageList: () => {},
  setLivePerson: () => {},
  livePerson: 0,
  endLive: false,
  currentMessageList: [],
};

@inject(({ LiveMessageList }) => ({
  currentMessageList: LiveMessageList.currentMessageList,
  preScrollHeight: LiveMessageList.preScrollHeight,
  endLive: LiveMessageList.endLive,
  livePerson: LiveMessageList.livePerson,

  getMessageLists: LiveMessageList.getMessageLists,
  pushCurrentMessageList: LiveMessageList.pushCurrentMessageList,
  setConversationID: LiveMessageList.setConversationID,
  setEndLive: LiveMessageList.setEndLive,
  setLivePerson: LiveMessageList.setLivePerson,
}))
@observer
class Live extends Component {
  liveDetail = {}

  constructor(props) {
    super(props);

    const windowHref = `?${decodeURIComponent(window.location.href).split('?')[1]}`;

    // const record = queryString.parse(windowHref).isRecord;

    const urlSearch = {
      streamName: queryString.parse(windowHref).streamName || '',
      userId: queryString.parse(windowHref).userId || '',
      userName: queryString.parse(windowHref).userName === 'undefined' ? '' : queryString.parse(windowHref).userName,
      verifyType: queryString.parse(windowHref).verifyType || '0',
      headUrl:
        queryString.parse(windowHref).headUrl
        || 'http://lets-sell.oss-cn-beijing.aliyuncs.com/df5f9308bb42bbdce5bf83e505272e60.png',
      groupId: queryString.parse(windowHref).groupId || '',
      isApp: queryString.parse(windowHref).isApp || '',
      isRecord: queryString.parse(windowHref).isRecord && queryString.parse(windowHref).isRecord.split('=')[0] === '1', // 是否录播
      isRecordQuery: queryString.parse(windowHref).isRecord && queryString.parse(windowHref).isRecord.split('=')[0], // 是否录播
      liveId: queryString.parse(windowHref).liveId || '',

      isMyLive: queryString.parse(windowHref).isMyLive, // 是不是我的直播
      shareUserId: queryString.parse(windowHref).userId, // 分享人ID
    };

    this.state = {
      ...urlSearch,
      value: '',
      // messageList: [],
      preScrollHeight: 0,
      isShowScrollButtomTips: false, // 是否滚动到底部
      modal2: false,
      myAvatar: null,
      myNick: null,
      liveIntroduce: undefined,
      introducePic: undefined,
      inputFlag: true,
      livePicture: null, // 直播封面图
      plugFlowAddress: null, // 视频直播播放链接
      enterRoom: false, // 禁入直播间配置参数是否初始化完成标志
      liveName: null,
      spList: [], // 直播关联商品
      signature: null, // 签名
      liveLoginVisible: false, // 是否需要手机号验证
      mobile: undefined,
      // memberList: [], // 成员数据
      fileId: null, // 录播视频ID
      relatedProducts: [], // 关联商品
      isSDKReady: false, // sdk是否初始化完成
      animating: false, // loading指示器

      // oQd0LwFd0nlDdQLIDkI2bg-61Z0U
    };

    const { groupId } = this.state;

    // 设置群聊ID
    props.setConversationID(groupId);

    // 初始化监听器
    this.initListener();

    document.title = '直播';
  }

  componentDidMount() {
    const {
      userId, userName, headUrl, isApp, isRecord,
    } = this.state;
    const app = isApp === '1';

    const isWeixinClient = tools.isWeixinCient();
    if (isWeixinClient) this.getLiveOpenId(); // 微信授权
    if (!isRecord && app) this.getImUserSig(userId, '', userName, headUrl);
    if (isRecord && app) this.verifyVodLive();
  }

  /**
   * IM Sdk是否处于ready状态
   * @param name
   * @returns {Promise<void>}
   */
  onReadyStateUpdate({ name }) {
    // const { getMessageLists } = this.props
    const isSDKReady = name === TIM.EVENT.SDK_READY;
    this.setState({ isSDKReady: name === TIM.EVENT.SDK_READY });
    if (isSDKReady) {
      // 拉取历史消息
      // getMessageLists().then(() => {
      // this.scrollToBottom()
      // });
      this.setState({ animating: false });
      tim.getMyProfile().then((res) => {
        // 获取本人的昵称，头像。用于发送消息
        const url = res.data.avatar && res.data.avatar !== 'null'
          ? res.data.avatar
          : 'http://lets-sell.oss-cn-beijing.aliyuncs.com/df5f9308bb42bbdce5bf83e505272e60.png';
        this.setState({ myNick: res.data.nick, myAvatar: url });
      });
    }
  }

  /**
   * 监听是否存在新消息
   * @param messageList
   */
  onReceiveMessage({ data: messageList }) {
    const { pushCurrentMessageList } = this.props;
    const { preScrollHeight } = this.state;
    pushCurrentMessageList(messageList);

    if (messageList[0].conversationType !== '@TIM#SYSTEM' && !!preScrollHeight) { this.setState({ isShowScrollButtomTips: true }); }
  }

  static onError({ data }) {
    if (data.message !== 'Network Error') {
      // Toast.show(data.message);
    }
  }

  /**
   * 微信授权,
   * @returns {Promise<void>}
   */
  getLiveOpenId = async () => {
    const windowHref = `?${decodeURIComponent(window.location.href).split('?')[1]}`;
    const isWeixinClient = tools.isWeixinCient();
    const WXCode = queryString.parse(windowHref).code;
    if (!isWeixinClient) return;

    if (!WXCode) {
      localStorage.clear();
      // 动态获取 微信 appId
      try {
        const { code, data, message } = await getImAppId();

        if (code === 10000) window.location.href = tools.toWxth(data);
        else Toast.show(message || '获取微信 appId 失败');
      } catch (e) {
        Toast.show(e || '获取微信 appId 失败');
      }
    } else if (!localStorage.getItem('openId')) {
      try {
        const { code, data } = await getImOpenId(WXCode);
        if (code === 10000) {
          localStorage.setItem('openId', data.openid);
          localStorage.setItem('nickname', data.nickname);
          localStorage.setItem('headimgurl', data.headimgurl);
          this.getImUserSig('', data.openid, data.nickname, data.headimgurl);
        }
      } catch (e) {
        Toast.show(e);
      }
    } else {
      this.getImUserSig(
        '',
        localStorage.getItem('openId'),
        localStorage.getItem('nickname'),
        localStorage.getItem('headimgurl'),
      );
    }
  }

  /**
   * 获取IM签名
   * @param userId
   * @param openId
   * @param name   昵称
   * @param headUrl  头像
   * @param type   是否首次注册
   * @returns {Promise<void>}
   */

  getImUserSig = async (userId, openId, name, headUrl, type = 0) => {
    const { isApp, isRecord } = this.state;
    const app = isApp === '1';

    try {
      // this.setState({ animating: true });
      const { data, code, message } = await getImUserSig(
        app ? userId : openId, name, headUrl, type,
      );
      if (code === 10000) {
        if (!app) this.getOpenType(data, userId, openId, name);
        if (!isRecord && app) this.imLogin(userId, openId, data, name);
        this.setState({ animating: false });
      } else {
        Toast.show(message);
        this.setState({ animating: false });
      }
    } catch (e) {
      this.setState({ animating: false });
    }
  }

  /**
   * 校验是否需要填写手机号
   * @param signature
   * @param userId
   * @param openId
   * @param name
   * @returns {Promise<void>}
   */
  getOpenType = async (signature, userId, openId, name) => {
    const { streamName, isRecord, liveId } = this.state;

    try {
      this.setState({ animating: true });
      const { code, data, message } = await getOpenType(streamName, openId, isRecord ? liveId : '');
      if (code === 10000) {
        if (data.openType === '1') {
          this.setState({ liveLoginVisible: true, signature });
        } else if (!isRecord) {
          this.imLogin(userId, openId, signature, name);
        } else {
          this.verifyVodLive();
        }
      } else {
        this.setState({ animating: false });
        Toast.show(message);
      }
    } catch (e) {
      Toast.show(e);
    }
  }

  /**
   * 检验手机号验证码
   */
  handleMobileLogin = async (mobile, qcode) => {
    const { signature, userId, isRecord } = this.state;
    const openId = localStorage.getItem('openId');
    const nickname = localStorage.getItem('nickname');
    if (!mobile) return Toast.show('请填写手机号');
    if (mobile.length !== 11) return Toast.show('手机号格式不正确');
    if (!qcode) return Toast.show('请填写验证码');
    try {
      this.setState({ animating: true });

      const { code, message } = await checkCode('live', mobile, qcode);
      if (code === 10000) {
        this.setState({ mobile, liveLoginVisible: false, animating: false }, () => {
          if (!isRecord) {
            this.imLogin(userId, openId, signature, nickname);
          } else {
            this.verifyVodLive();
          }
        });
      } else {
        Toast.show(message);
        this.setState({ animating: false });
      }
    } catch (e) {
      this.setState({ animating: false });
    }
    return false;
  }

  /**
   * 进入录播间
   * @returns {Promise<void>}
   */

  verifyVodLive = async () => {
    const {
      streamName, isApp, mobile, userId, liveId, shareUserId,
    } = this.state;
    const openId = localStorage.getItem('openId');
    const userName = localStorage.getItem('nickname');
    try {
      this.setState({ animating: false });

      const { data, code, message } = await verifyVodLive(
        streamName,
        userName,
        userId,
        openId,
        isApp,
        mobile,
        liveId,
        shareUserId,
      );

      if (code === 10000) {
        this.setState({
          liveIntroduce: data.liveInfo.liveIntroduce,
          liveName: data.liveInfo.liveName,
          introducePic: data.liveInfo.introducePic,
          spList: data.liveInfo.spList,
          fileId: data.fileId,
          animating: false,
          commodityType: data.liveInfo.commodityType,
          extensionType: data.liveInfo.extensionType,
        });
        this.liveDetail = { ...data.liveInfo, liveId: data.liveId };
      } else {
        Toast.show(message);
        this.setState({ animating: false });
      }
    } catch (e) {
      this.setState({ animating: false });
    }
  }

  /**
   * IM SDK登录
   * @param userId
   * @param openId
   * @param data
   * @param name
   */
  imLogin = (userId, openId, data, name) => {
    const {
      streamName, groupId, isApp, mobile, shareUserId,
    } = this.state;
    const { setEndLive } = this.props;

    const app = isApp === '1';
    tim
      .login({
        userID: app ? userId : openId,
        userSig: data,
      })
      .then((res) => {
        if (res.data.actionStatus === 'OK') {
          this.setState({ animating: true });

          verifyGetLive(streamName, groupId, name, userId, openId, app ? '1' : '0', mobile, shareUserId)
            .then(({ data1, code, message }) => {
              if (code === 10000) {
                this.setState({
                  liveName: data1.liveInfo.liveName,
                  spList: data1.liveInfo.spList,
                  commodityType: data1.liveInfo.commodityType,
                  extensionType: data1.liveInfo.extensionType,
                });
                this.liveDetail = { ...data1.liveInfo, liveId: data1.liveId };
                setEndLive(data1.liveInfo.streamState === 'active');
                this.setState({ animating: false });
                Toast.show(message);
                this.setState({ enterRoom: false });
                setEndLive(false);
              }
            })
            .catch(() => {
              this.setState({ enterRoom: false });
              setEndLive(false);
            });
        }
      });
  }

  /**
   * 初始化SDK，所有SDK均在EVENT.SDK_READY ready之后方可调用
   */
  initListener = () => {
    // 登录成功后会触发 SDK_READY 事件，该事件触发后，可正常使用 SDK 接口
    tim.on(TIM.EVENT.SDK_READY, this.onReadyStateUpdate, this);
    // 收到新消息
    tim.on(TIM.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage, this);
    // SDK内部出错
    tim.on(TIM.EVENT.ERROR, Live.onError);
  }

  /**
   * 解决ios软键盘空白隐藏出现空白问题
   */
  scrollPosition = () => {
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
  }

  /**
   * 获取群成员列表，暂未使用
   * @param event
   */
  onConversationListUpdated = () => {
    const { groupId } = this.state;
    const that = this;
    const promise = tim.getGroupMemberList({
      groupID: groupId,
      count: 99999,
      offset: 0,
    }); // 从0开始拉取30个群成员
    promise
      .then((imResponse) => {
        that.setState({ memberList: imResponse.data.memberList });
      })
      .catch(() => {
        // console.warn('getGroupMemberList error:', imError);
      });
  }

  /**
   * 根据flow 判断是不是自己发送的消息，规定样式
   * @param flow
   * @returns {boolean}
   */
  isMine = (flow) => flow === 'out'

  handleInput = (e) => {
    this.setState({ value: e.target.value });
  }

  /**
   * 设置发送消息
   * @param e
   */
  handleMsg = () => {
    const { pushCurrentMessageList } = this.props;
    const { value, groupId, isSDKReady } = this.state;
    if (!value) {
      Toast.info('不能发送空白消息 !!!', 1);
      return;
    }
    const message = tim.createTextMessage({
      to: groupId,
      conversationType: TIM.TYPES.CONV_GROUP,
      payload: { text: value },
    });
    if (isSDKReady) tim.sendMessage(message);
    pushCurrentMessageList(message);
    this.setState({ value: '' }, () => {
      this.scrollToBottom();
    });
  }

  /**
   * 渲染聊天内容
   * @param item
   * @returns {*}
   */
  renderChatList = (item) => {
    const { myNick, myAvatar } = this.state;
    return (
      <div
        className={classnames(
          styles.messageItem,
          this.isMine(item.flow) ? styles.messageItemRight : styles.messageItemLeft,
        )}
      >
        <div>
          <img
            style={{ float: this.isMine(item.flow) ? 'right' : 'left' }}
            src={this.isMine(item.flow) ? myAvatar : item.avatar || moren}
            alt=""
          />
          <div className={styles.messageTitle}>{this.isMine(item.flow) ? myNick : item.nick}</div>
          <div
            className={this.isMine(item.flow) ? styles.textBoxRight : styles.textBoxLeft}
          >
            {item.payload.text}

          </div>
        </div>
      </div>
    );
  }

  /**
   * 底部输入框显示
   * @returns {*}
   */
  renderInput = () => {
    const { isSDKReady, value } = this.state;
    const { endLive } = this.props;
    return (
      <div className={styles.liveTalk}>
        <div style={{ position: 'relative', flex: 'auto' }}>
          <img className={styles.inputImg} src={pngInput} alt="" />
          <input
            onBlur={this.scrollPosition}
            readOnly={!isSDKReady || !endLive}
            className={styles.liveInput}
            type="text"
            value={value}
            placeholder={endLive ? '说点什么吧...' : '直播未开始或已结束，还不能聊天哦'}
            onChange={this.handleInput}
          />
        </div>
        <div className={styles.sendBtn} onClick={this.handleMsg} role="button" tabIndex={0}>
          发送
        </div>
      </div>
    );
  }

  /**
   * 获取消息列表
   * @returns {*}
   */

  renderMessageList = () => {
    const { currentMessageList } = this.props;
    if (!currentMessageList.length) return null;

    return currentMessageList.map((item) => (
      <div key={item.ID}>
        {item.conversationType === '@TIM#SYSTEM' ? this.renderWelcome(item) : this.renderChatList(item)}
      </div>
    ));
  }

  onClose = () => {
    this.setState({ modal2: false });
  }

  /**
   * 页面滚动至底部
   */
  scrollToBottom = () => {
    const { scrollHeight } = this.messagesEnd; // 里面div的实际高度
    this.messagesEnd.scrollTop = scrollHeight;
  }

  /**
   * 出现滚动区域时，当页面没在底部且收到新消息时 底部显示 查看最新消息按钮
   * @param scrollTop
   */
  onScroll = ({ target: { scrollTop } }) => {
    const messageListNode = this.messagesEnd;
    const { scrollHeight } = this.messagesEnd; // 里面div的实际高度

    const { clientHeight } = messageListNode; // 网页可见高度
    if (!messageListNode) {
      return;
    }
    this.setState({ preScrollHeight: scrollHeight });
    if (scrollHeight - clientHeight - scrollTop < 20) {
      this.setState({ isShowScrollButtomTips: false });
    }
  }

  open = () => {
    const { modal2, spList } = this.state;
    try {
      this.setState({ modal2: !modal2, animating: true }, async () => {
        const { code, data } = await getLiveProduct(spList);
        if (code === 10000) this.setState({ relatedProducts: data, animating: false });
        else this.setState({ animating: false });
      });
    } catch (e) {
      this.setState({ animating: false });
    }
  }

  handleTabs = (e) => {
    this.setState({ inputFlag: e.title === '聊天' });
  }

  /**
   * 关联商品价格回显
   * @param data
   * @returns {string|null}
   */
  renderPrice = (data) => {
    const isOpenAccount = data.templateType === 4;

    if (isOpenAccount) {
      // 开户模式
      return null;
    }
    switch (data.priceType) {
      case 1: {
        return '报价单';
      }
      case 2: {
        // 一口价
        return `￥${tools.getMoney(data.price)}`;
      }
      case 3: {
        // 区间价
        return `￥${tools.getMoney(data.intervalPriceLeft)} - ￥${tools.getMoney(data.intervalPriceRight)}`;
      }
      case 4: {
        // 组合价
        return `￥${tools.getMoney(data.specPrice)}`;
      }
      default:
        return '';
    }
  }

  /**
   * 点击商品跳转详情
   * @param item
   */

  handleProduct = (item) => {
    const { history } = this.props;
    const { userId } = this.state;
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'buyProduct',
          id: item.id,
        }),
      );
    } else {
      const { liveId = '', streamName = '' } = this.liveDetail;
      history.push(
        `/productDetail?shareUserId=${userId}&productId=${item.id}&liveId=${liveId}&streamName=${streamName}`,
      );
    }
  }

  /**
   * 渲染关联商品列表
   */
  renderLinkProduct = () => {
    const { relatedProducts } = this.state;
    if (!relatedProducts || !relatedProducts.length) return null;
    return relatedProducts.map((item) => (
      <div className={styles.linkPro} key={item.productName} onClick={this.handleProduct.bind(this, item)} role="button" tabIndex={0}>
        <img src={item.imgUrl ? item.imgUrl : linkProduct} alt="关联商品" />
        <div>
          <div className={styles.ling_pro_title}>{item.productName}</div>
          <div className={styles.ling_pro_price}>{this.renderPrice(item)}</div>
        </div>
      </div>
    ));
  }

  /**
   * 与App通信，分享，下载，复制链接
   * @returns {*}
   */

  handleH5ToApp = (type) => {
    const massageData = [
      { title: 'promotion' }, // 推广赚钱
      { title: 'productList' }, // 商品列表
    ];
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: massageData[type].title,
        }),
      );
    }
  }

  /**
   * 根据录播直播，设置Tabs标签，
   * @returns {*}
   */

  handleTabsData = () => {
    const { isRecord } = this.state;
    const tabs = [{ title: '聊天' }, { title: '直播介绍' }];
    if (isRecord) {
      tabs.splice(0, 1);
    }
    return tabs;
  }

  /**
   * 渲染欢迎语
   * @param item
   * @returns {*}
   */
  renderWelcome = (item) => {
    const { setEndLive, setLivePerson } = this.props;
    if (!item.payload.userDefinedField) return null;

    const payload = JSON.parse(item.payload.userDefinedField);
    if (payload.MsgType === 'text') {
      return <div className={styles.welcome}>{payload.MsgContent}</div>;
    }
    if (payload.MsgType === 'online') {
      setLivePerson(payload.MsgContent);
    }
    if (payload.MsgType === 'end') {
      setEndLive(false);
    }
    if (payload.MsgType === 'start') {
      setEndLive(true);
    }
    return true;
  }

  /**
   * 直播设置
   * @returns {*}
   */
  handleLive = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'setupLive',
        }),
      );
    }
  }

  render() {
    // const isWeixinClient = tools.isWeixinCient()

    const {
      isShowScrollButtomTips,
      inputFlag,
      livePicture,
      plugFlowAddress,
      enterRoom,
      streamName,
      liveLoginVisible,
      isRecord,
      liveIntroduce,
      liveName,
      introducePic,
      shareUserId,
      isMyLive,
      isApp,
      spList,
      userId,
      liveId,
      fileId,
      isRecordQuery,
      extensionType,
      commodityType,
      modal2,
      animating,
    } = this.state;
    const { endLive, livePerson } = this.props;
    const shareUrl = `${window.location.hostname
      + window.location.pathname
    }?streamName=${streamName}&userId=${userId}&isRecord=${isRecordQuery}&isApp=${isApp}
      &liveId=${liveId}&shareUserId=${shareUserId}`;

    // if (!isWeixinClient) return <div className={styles.noWx}>请在微信中打开此链接</div>

    return (
      <div>
        {enterRoom && endLive ? (
          <LiveComponent
            endLive={endLive}
            appName="live"
            streamName={streamName}
            liveUrl={config.liveUrl}
            poster={livePicture}
            params={`?${plugFlowAddress && plugFlowAddress.split('?')[1]}`}
          />
        ) : !endLive ? (
          <div className={styles.blankBox}>
            {Number(isMyLive) === 1 && Number(isApp) === 1 ? (
              <div className={styles.liveTitle} onClick={this.handleLive} role="button" tabIndex={0}>
                直播设置
              </div>
            ) : (
              <div className={styles.liveTitleText}>直播未开始或已结束</div>
            )}
            <div className={styles.liveStatus}>
              <img src={noLive} alt="" />
              未开播
            </div>
          </div>
        ) : (
          <div className={styles.blankBox} />
        )}
        {/* 录播 */}
        {isRecord && !!fileId && <TencentVideoPLay fileId={fileId} />}
        <Tabs
          tabBarUnderlineStyle={{
            border: '2px rgba(0, 106, 255, 1) solid',
            borderRadius: '2px',
          }}
          tabBarActiveTextColor="#000"
          tabBarInactiveTextColor="#969696"
          useOnPan={false}
          tabs={this.handleTabsData()}
          onChange={this.handleTabs}
        >
          {!isRecord ? (
            <div
              onScroll={this.onScroll}
              className={styles.chatItem}
              ref={(el) => {
                this.messagesEnd = el;
              }}
            >
              {this.renderMessageList()}
              <div
                className={styles.back}
                style={{ display: isShowScrollButtomTips ? 'block' : 'none' }}
                onClick={this.scrollToBottom}
                role="button"
                tabIndex={0}
              >
                回到最新位置
              </div>
            </div>
          ) : (
            <div className={styles.liveIntroduce}>{liveIntroduce}</div>
          )}

          <div className={styles.liveIntroduce}>
            {liveIntroduce}
            <img src={introducePic} alt="" />
          </div>
        </Tabs>
        {inputFlag && this.handleTabsData().length !== 1 ? this.renderInput() : null}
        {window.ReactNativeWebView && Number(extensionType) === 1 && (
          <SuspendButton
            img={pngTuiguang}
            style={{ top: '400px' }}
            onClick={this.handleH5ToApp.bind(this, 0)}
          />
        )}
        {Number(commodityType) === 1 && (
          <SuspendButton
            img={pngShangpin}
            style={{ top: '460px' }}
            onClick={this.open}
            text={spList.length}
          />
        )}
        {inputFlag && !isRecord ? (
          <div className={styles.onlinePer}>
            <img src={pngOnline} alt="" />
            在线人数：
            {livePerson}
          </div>
        ) : null}
        <Modal
          // className={styles.popupBox}
          popup
          title="关联商品"
          visible={modal2}
          closable
          animationType="slide-up"
          // afterClose={() => { alert('afterClose'); }}
          onClose={this.onClose}
        >
          <div className={styles.popupBox}>{this.renderLinkProduct()}</div>
        </Modal>
        <LiveLogin
          handleMobileLogin={this.handleMobileLogin}
          liveLoginVisible={liveLoginVisible}
        />
        {enterRoom
        && <WXShare title={liveName} imgUrl={livePicture} desc={liveIntroduce} link={shareUrl} />}
        <ActivityIndicator toast animating={animating} />
      </div>
    );
  }
}

Live.propTypes = propTypes;
Live.defaultProps = defaultProps;

export default Live;
